import { AfterContentInit, Directive, ElementRef, inject, Input } from '@angular/core';

@Directive({
  selector: '[appAutoFocus]',
  standalone: false,
})
export class AutoFocusDirective implements AfterContentInit {
  private readonly el = inject(ElementRef);

  @Input() public appAutoFocus: boolean;

  public ngAfterContentInit() {
    if (this.appAutoFocus) {
      setTimeout(() => {
        this.el.nativeElement.focus();
      }, 100);
    }
  }
}
